import { render, staticRenderFns } from "./HistoricSearchFilter.vue?vue&type=template&id=5811fe82&scoped=true&"
import script from "./HistoricSearchFilter.vue?vue&type=script&lang=ts&"
export * from "./HistoricSearchFilter.vue?vue&type=script&lang=ts&"
import style0 from "./HistoricSearchFilter.vue?vue&type=style&index=0&id=5811fe82&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5811fe82",
  null
  
)

export default component.exports